import type { GemsApi_StoneShape } from '@/graphql/api'

export const allowedShapes = [
    'ASSCHER',
    'CUSHION',
    'EMERALD',
    'HEART',
    'HEXAGONAL',
    'MARQUISE',
    'OVAL',
    'PEAR',
    'PRINCESS',
    'RADIANT',
    'ROUND',
] as const satisfies Readonly<GemsApi_StoneShape[]>
export type AllowedStoneShapes = (typeof allowedShapes)[number]
